import { render, staticRenderFns } from "./MessageBox.vue?vue&type=template&id=3b46bea6&scoped=true&"
import script from "./MessageBox.vue?vue&type=script&lang=js&"
export * from "./MessageBox.vue?vue&type=script&lang=js&"
import style0 from "./MessageBox.vue?vue&type=style&index=0&id=3b46bea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vbimex/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b46bea6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../vbimex/admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDivider,VFlex,VIcon,VLayout,VList,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VSelect,VTextField})
